
export type ImageRegistrationTransform = {
  translation: { x: number; y: number };
  rotation: number;
  scale: number;
};

export type ImageLookup = {
  filepath: string;
  eye: string;
  type: string;
  subImageKey?: string;
};

export type ImageRegistration = {
  FAF: ImageRegistrationTransform;// | null;
  FAFONH: ImageRegistrationTransform;// | null;
  FixedImage: ImageLookup;// | null;
};

// The clicked registration point pairs (in image pixel coordinates) that
// produced a saved transform. src[i] (unfixed image) pairs with dst[i]
// (fixed image), already aligned to the winning pairing order.
export type RegistrationPointPairs = {
  src: number[][];
  dst: number[][];
};

export type RegistrationPoints = {
  OD?: { FAF?: RegistrationPointPairs; FAFONH?: RegistrationPointPairs };
  OS?: { FAF?: RegistrationPointPairs; FAFONH?: RegistrationPointPairs };
};

export interface BScanData {
  totalScans: number;
  scanIndex: number;
  scanX: number;
  enfaceX: number;
  enfaceY: number;
}

export interface LocalizerData {
  version: number;
  timestamp: number;
  captureDate: string;
  studyEye: 'OD' | 'OS' | null;
  registrations: {
    OD: ImageRegistration | null;
    OS: ImageRegistration | null;
  };
  fovealPit: {
    OD: BScanData | null;
    OS: BScanData | null;
  };
  // Additive optional key (no version bump): point pairs behind each saved
  // registration transform. Absent in layouts saved before this was added.
  registration_points?: RegistrationPoints;
  filenames: string[];
}

// registration_points is optional/additive: it passes through both branches
// below unchanged (absent keys stay absent, present keys are preserved).
export function upgradeLocalizerData(data): LocalizerData {
  if ('version' in data === false || data.version < 2) {
    let reg = data.registrations;
    return {
      ...data,
      version: 2,
      captureDate: data.captureDate.slice(0, 10),
      registrations: !reg ? null : {
        OD: !reg.FAF.OD ? null : {
          FAF: reg.FAF.OD,
          FAFONH: reg.FAFONH.OD,
          FixedImage: reg.FixedImage.OD,
        },
        OS: !reg.FAF.OS ? null : {
          FAF: reg.FAF.OS,
          FAFONH: reg.FAFONH.OS,
          FixedImage: reg.FixedImage.OS,
        },
      },
    };
  }
  return data;
}

export {}
